import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip } from '@chakra-ui/react';

import SecondaryButton from './SecondaryButton';
import { ReactComponent as FilterCheckIcon } from '../../icons/mdi-filter-check-soft-warning.svg';
import { ReactComponent as FilterOffIcon } from '../../icons/mdi-filter-off.svg';

const FiltersButton = ({ hasIndicator, children, tooltip, style, ...rest }) => {
    const intl = useIntl();
    tooltip = tooltip ? tooltip : intl.formatMessage({ id: 'common_filters_btn_tooltip' });
    return (
        <Tooltip label={tooltip} shouldWrapChildren sx={style}>
            <SecondaryButton
                leftIcon={hasIndicator ? <FilterCheckIcon /> : <FilterOffIcon />}
                type="button"
                variant="secondary"
                size="sm"
                {...rest}
            >
                {children || <FormattedMessage id="common_filters_btn" />}
            </SecondaryButton>
        </Tooltip>
    );
};

export default FiltersButton;
